/**
 * Microsoft Authentication Library (MSAL) configuration for Azure AD integration
 */

import { Configuration, LogLevel } from '@azure/msal-browser';
import { AZURE_AD_CONFIG, DEV_MODE } from './env';

/**
 * MSAL Configuration object
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: AZURE_AD_CONFIG.clientId,
        authority: AZURE_AD_CONFIG.authority,
        redirectUri: AZURE_AD_CONFIG.redirectUri,
        postLogoutRedirectUri: AZURE_AD_CONFIG.postLogoutRedirectUri,
        navigateToLoginRequestUrl: true, // Set to true for redirect authentication
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is recommended for SPAs.
        storeAuthStateInCookie: false, // Set this to true if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error('[MSAL Error]', message);
                        return;
                    case LogLevel.Info:
                        if (DEV_MODE) {
                            console.info('[MSAL Info]', message);
                        }
                        return;
                    case LogLevel.Verbose:
                        return;
                    case LogLevel.Warning:
                        console.warn('[MSAL Warning]', message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: DEV_MODE ? LogLevel.Verbose : LogLevel.Warning,
        },
    },
};

/**
 * Scopes for login request (user profile access only)
 */
export const loginRequest = {
    scopes: AZURE_AD_CONFIG.scopes,
};

/**
 * Scopes for Graph API calls (user profile, etc.)
 */
export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
    scopes: ['User.Read'],
};

/**
 * API request configuration for backend access
 */
export const apiRequest = {
    scopes: AZURE_AD_CONFIG.apiScopes,
};